module.exports = __webpack_public_path__ + "static/6305-woodrose-18-ee13d0197f9a0de3aa991437dd5930fd.jpg";